import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Output,
    QueryList,
    SimpleChanges,
    ViewChild,
    ViewChildren,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DashboardComponent } from 'src/app/admin/core/components/dashboard/dashboard.component';
import { HttpclientService } from 'src/app/admin/core/services/httpclientService';
import { TemplateService } from 'src/app/services/template.service';
import { v4 as uuidv4 } from 'uuid';
import { Col } from 'src/app/shared/entities/col';
import { DeleteReq } from 'src/app/shared/entities/deleteReq';
import { Language } from 'src/app/shared/entities/language';
import { Parametre } from 'src/app/shared/entities/parametre';
import { Row } from 'src/app/shared/entities/row';
import { Template } from 'src/app/shared/entities/template';
import { MenuActions } from 'src/app/shared/enums/menu-actions';
import { PageOptions } from 'src/app/shared/enums/page-modes';
import { TabService } from 'src/app/shared/services/tab.service';
import { DiaologHostComponent } from 'src/app/shared/components/dialogs/dialog-host/dialog-host';
import { AppDynamicComponent } from 'src/app/shared/components/dynamic-component-shared/app-dynamic.component';
import { LayoutCondition } from 'src/app/shared/entities/layoutCondition';
import { UserService } from 'src/app/admin/core/services/user.service';
import {
    DynamicDocumentFieldInfo,
    DynamicDocumentFieldInfoType,
    DynamicDocumentInfo,
} from 'src/app/shared/entities/dynamic-document';
import { DynamicDocumentInfoService } from 'src/app/shared/services/dynamic-document-info.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { Tables } from '../../entities/tables';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-template-edit',
    templateUrl: './template-edit.component.html',
    styleUrls: ['./template-edit.component.css'],
})
export class TemplateEditComponent implements OnInit, OnDestroy {
    public _initTemplates: { [id: string]: Template } = {};

    public templates: { [id: string]: Template } = {};

    @Input() public tab: any;
    @Input() public value: any;

    typeName: any;
    data: any;
    config: any;
    errorMessage: any;
    isEditMode = false;
    isLayoutEditMode = false;
    pageMode: PageOptions.EDIT;
    columnGauche: any;
    columnDroite: any;
    lectureMode: boolean = true;
    isOpenLanguages: boolean = false;
    totalElements: number = 0;
    showIntermediaryApprovalButton: boolean = false;

    languages: Language[] = environment.languages.map((lang, index) => {
        return { key: lang.locale, label: lang.text, selected: index === 0 };
    });
    entitypropertydisplay: any[] = [
        { key: 'produit', label: 'code' },
        { key: 'catégorie', label: 'code' },
        {
            key: 'variablelogistique',
            label: 'Libellé VL',
            value: 'libelle',
            type: 'multiLangue',
        },
        { key: 'sousFamille', label: 'code' },
        { key: 'sousSousFamille', label: 'code' },
        { key: 'sousSousSousFamille', label: 'code' },
        { key: 'sousSousSousSousFamille', label: 'code' },
    ];
    entitiespourvalidation: any[] = ['produit'];
    parametersConnections: { [id: string]: string[] } = {};

    allParameters: Parametre[] = [];
    isfiedvalidated: boolean = true;

    allTemplates: { [id: string]: string } = {};
    templateIdSelected: string | null = null;

    @Output() public menuAction: EventEmitter<MenuActions> = new EventEmitter<MenuActions>();
    deleteReq: DeleteReq = new DeleteReq();
    mylabel: string = 'Enregistrer';
    hasAllRequiredRolesValidated: boolean = false;

    auditLogs: any[] | null = null;

    dynamicDocumentInfo: DynamicDocumentInfo;

    get isDynamic() {
        return this.dynamicDocumentInfo !== null && this.dynamicDocumentInfo !== undefined;
    }

    get isCreation() {
        return this.tab?.title?.toString().includes('Création');
    }

    tempData: any;

    // @ViewChild(AppDynamicComponent) dynamicComponent: AppDynamicComponent;
    @ViewChildren(AppDynamicComponent) childComponents!: QueryList<any>;
    constructor(
        private httpclientService: HttpclientService,
        private templateService: TemplateService,
        private dialog: MatDialog,
        private dash: DashboardComponent,
        private myTableService: TabService,
        public userService: UserService,
        public tabService: TabService,
        private readonly _dynamicDocumentInfoService: DynamicDocumentInfoService,
        private readonly _dynamicDocumentService: DynamicDocumentService,
        private datePipe: DatePipe
    ) {
        this.languages.push({ key: 'all', label: 'Toutes les langues', selected: false });
        // this.tabService.updateTemplateEvent.subscribe((newObj) => {
        //   this.data = newObj;
        // });

        this.myTableService.updateTemplateEvent.subscribe(({ tabId, data }) => {
            // Handle the data for the specific tab identified by tabId
            if (tabId === this.tab.id) {
                this.data = data;
                // Handle the data for the current tab

                // Update the component's data or perform any necessary operations
            } else {
                // Handle the data for other tabs
                // Update the component's data or perform any necessary operations
            }
        });
    }

    trackByParam(index: number, param: any) {
        return param.id || param.name || index;
    }

    async ngOnDestroy(): Promise<void> {
        // Save data before component is destroyed
        // This applies to both edit mode and creation mode for all entities
        if (
            (this.isEditMode || this.isCreation) &&
            this.childComponents &&
            this.childComponents.length > 0
        ) {
            try {
                const tempData = await this.templateService
                    .processEnregister(this.childComponents, this.tab, this.isDynamic, true)
                    .toPromise();

                if (tempData) {
                    // Save data for current active tab
                    if (this.isCreation && this.tab?.entite) {
                        // For creation mode: save with entity name (works for all entities: rates, articles, etc.)
                        this.tabService.saveEditDataForCreation(
                            this.tab.entite,
                            tempData,
                            this.activeTab
                        );
                    } else if (this.tab?.id) {
                        // For edit mode: save with tab.id
                        this.tabService.saveEditData(this.tab.id, tempData, false, this.activeTab);
                        // Also save to tabId for backward compatibility
                        this.tabService.saveEditData(this.tab.id, tempData, false);
                    }
                }
            } catch (error) {
                console.error('Error saving data on destroy:', error);
            }
        } else if (this.tab?.id) {
            this.tabService.saveEditData(this.tab.id, null, true);
        }
    }

    // ngAfterContentChecked() {
    //   this.cdref.detectChanges();
    // }
    async ngOnInit(): Promise<void> {
        if (this.tab.isRecordDuplication) {
            this.data = this.tab?.data;
            this.data.id = null;
            this.tab.entite = this.tab?.typeName;
            this.tab.droitTitle = this.tab?.droitTitle;
            this.isEditMode = true;
            this.lectureMode = false;
            this.dynamicDocumentInfo = this.tab.dynamicDocumentInfo;
            this.templates = this.tab?.templates;
            this.templateIdSelected = this.tab?.templateIdSelected;
        } else {
            if (this.value == 'edition') {
                this.isEditMode = true;
                this.lectureMode = false;
            }

            let dynamicDocument: any;
            if (!this.tab.entite.includes('dynamic')) {
                if (this.isEditMode) {
                    this.data = {};
                }

                const url: string = `template/${this.tab.entite.toLowerCase() + 'dto'}`;
                const rs = await this.httpclientService.get(url).toPromise();

                if (rs !== null) {
                    for (let template of rs) {
                        this.templates[template.id] = template;
                        this.allTemplates[template.id] = this.templates[template.id].titre;
                    }
                    this._initTemplates = JSON.parse(JSON.stringify(this.templates));
                }

                this.getData();
                this.typeName = this.tab.entite;
            } else {
                this.retrieveDynamicDocumentInfo(this.tab.entite)
                    .then(async (docInfo) => {
                        if (docInfo) {
                            this.dynamicDocumentInfo = docInfo;
                            this.tab.isDynamic = true;
                            this.tab.droitTitle = this._dynamicDocumentInfoService.getLabel(
                                this.dynamicDocumentInfo
                            );

                            this.retrieveDynamicDocument(
                                this.dynamicDocumentInfo.documentName,
                                this.tab.id
                            )
                                .then((doc) => {
                                    if (doc) {
                                        dynamicDocument = doc;

                                        this.data = dynamicDocument;

                                        this.checkPatchTempData();

                                        // Init template
                                        this.templateService
                                            .getTemplateByDocumentName(
                                                this.dynamicDocumentInfo.documentName
                                            )
                                            .then((templates: any) => {
                                                if (templates !== null && templates.length > 0) {
                                                    // Document has templates
                                                    templates.forEach(
                                                        (template: any, index: number) => {
                                                            const templateTmp =
                                                                this.checkParameterNotIncludes(
                                                                    template
                                                                );
                                                            this.templates[template.id] =
                                                                templateTmp;
                                                            this.allTemplates[template.id] =
                                                                template.titre;
                                                            this.templateIdSelected =
                                                                this.findGoodTemplate(); // Select last saved template

                                                            if (index === templates.length - 1) {
                                                                this.initAllParameters();
                                                            }
                                                        }
                                                    );
                                                } else {
                                                    // Document has no templates
                                                    this.initDefaultTemplate();
                                                }
                                            })
                                            .catch((err) => {
                                                // Document has no templates
                                                this.initDefaultTemplate();
                                            });
                                    }
                                })
                                .catch((err) => {
                                    if (this.isCreation) {
                                        this.checkPatchTempData();

                                        this.templates[this.tab.template.id] = this.tab.template;

                                        this.templates[this.tab.template.id] =
                                            this.checkParameterNotIncludes(this.tab.template);
                                        this.allTemplates[this.tab.template.id] =
                                            this.tab.template.titre;
                                        this.templateIdSelected = this.tab.template.id;
                                        this.initAllParameters();
                                    } else this.initDefaultTemplate();
                                });
                        } else {
                            throw 'NOT DYNAMIC';
                        }
                    })
                    .catch(async (err) => {
                        // NOT DYNAMIC
                    });
            }
        }
    }

    checkParameterNotIncludes(template: Template): Template {
        const allParametersName: string[] = [];

        const locales: string[] = this.languages
            .filter((language) => language.selected)
            .map((language) => language.key);

        if (template.layout !== undefined || template.layout !== null) {
            template.layout.tabs.forEach((t) => {
                t.rows.forEach((r) => {
                    r.cols.forEach((c) =>
                        c.parameters.forEach((p) => {
                            this.checkReplaceData(this.dynamicDocumentInfo, p.name, locales, p);
                            allParametersName.push(p.name);
                        })
                    );
                });
            });
        }

        if (template.parameters !== undefined && template.parameters !== null) {
            template.parameters.forEach((p) =>
                this.checkReplaceData(this.dynamicDocumentInfo, p.name, locales, p)
            );

            this.dynamicDocumentInfo.fields.forEach((fields) => {
                const find = template.parameters.find((item) => item.name === fields.name);

                if (!find && !allParametersName.includes(fields.name)) {
                    template.parameters.push(
                        this.getNewFieldData(this.dynamicDocumentInfo, fields, locales)
                    );
                }
            });
        }

        return template;
    }

    checkPatchTempData() {
        if (this.isEditMode || this.isCreation) {
            // Try to get data for current active tab first, then fallback
            if (this.isCreation && this.tab?.entite) {
                // Check if this is a fresh creation (not restoring from previous session)
                // If tab has a flag indicating it's a new creation, don't restore old data
                const isFreshCreation = (this.tab as any).isFreshCreation === true;
                
                if (!isFreshCreation) {
                    // Only restore data if this is NOT a fresh creation
                    // This prevents restoring old data when creating new article after closing previous one
                    this.tempData =
                        this.tabService.getTempEditDataForCreation(this.tab.entite, this.activeTab) ||
                        this.tabService.getTempEditDataForCreation(this.tab.entite);
                } else {
                    // Fresh creation: clear any old data and start fresh
                    this.tabService.clearTempEditDataForCreation(this.tab.entite);
                    this.tabService.clearActiveTabIndexForCreation(this.tab.entite);
                    this.tempData = null;
                    // Reset the flag after clearing
                    (this.tab as any).isFreshCreation = false;
                }
            } else if (this.tab?.id) {
                this.tempData =
                    this.tabService.getTempEditData(this.tab.id, this.activeTab) ||
                    this.tabService.getTempEditData(this.tab.id);
            }
        }
    }

    initDefaultTemplate() {
        const template: Template = this.toTemplate(this.dynamicDocumentInfo);
        this.templateIdSelected = template.id;
        this.templates[this.templateIdSelected] = template;
        this.allTemplates[this.templateIdSelected] = this.templates[this.templateIdSelected].titre;
        this._initTemplates = JSON.parse(JSON.stringify(this.templates));
        this.initAllParameters();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['tab']) {
            this.tab = changes['tab'].currentValue;
            this.isEditMode = this.tab.edition;
            this.typeName = this.tab.entite;
            this.tab.droitTitle = this.tab.droitTitle;
        }
    }

    private initAllParameters() {
        if (this.currentTemplate === undefined || this.currentTemplate == null) {
            return;
        }

        if (this.currentTemplate.layout === undefined || this.currentTemplate.layout == null) {
            return;
        }

        // Restore active tab index from localStorage (UX improvement)
        // Only restore after template is initialized
        // Use setTimeout to ensure mat-tab-group is rendered before setting selectedIndex
        if (this.currentTemplate?.layout?.tabs) {
            setTimeout(() => {
                // Re-check currentTemplate in case it changed during async operations
                if (!this.currentTemplate?.layout?.tabs) {
                    return;
                }

                let savedTabIndex: number | null = null;
                const tabsLength = this.currentTemplate.layout.tabs.length;

                // Check if in creation mode or edit mode
                if (this.isCreation && this.tab?.entite) {
                    // For creation mode: Always start at tab 0 (General Information)
                    // Don't restore previous tab index when creating new article/entity
                    // Each new creation must go to the general information tab
                    savedTabIndex = 0;
                } else if (this.tab?.id) {
                    // For edit mode: use tab.id as key
                    savedTabIndex = this.tabService.getActiveTabIndex(this.tab.id);
                }

                if (savedTabIndex !== null && savedTabIndex >= 0 && savedTabIndex < tabsLength) {
                    this.isRestoringTab = true;
                    this.activeTab = savedTabIndex;
                    // Also restore tempData for the restored tab
                    if (this.isEditMode || this.isCreation) {
                        let savedData: any = null;
                        if (this.isCreation && this.tab?.entite) {
                            savedData = this.tabService.getTempEditDataForCreation(
                                this.tab.entite,
                                savedTabIndex
                            );
                        } else if (this.tab?.id) {
                            savedData = this.tabService.getTempEditData(this.tab.id, savedTabIndex);
                        }
                        if (savedData) {
                            this.tempData = savedData;
                        }
                    }
                    // Reset flag after a tick to allow normal tab changes
                    setTimeout(() => {
                        this.isRestoringTab = false;
                    }, 0);
                }
            }, 0);
        }

        const allParameters: Parametre[] = [];

        this.currentTemplate.layout.tabs.forEach((t) => {
            t.rows.forEach((r) => {
                r.cols.forEach((c) => c.parameters.forEach((p) => allParameters.push(p)));
            });
        });

        if (
            this.currentTemplate.parameters !== undefined &&
            this.currentTemplate.parameters !== null
        ) {
            this.currentTemplate.parameters.forEach((p) => allParameters.push(p));
        }

        this.allParameters = [...new Set(allParameters)];
        this.allParameters.sort((a: Parametre, b: Parametre) => {
            const aStr = (a.label !== '' ? a.label : a.name)?.toLowerCase();
            const bStr = (b.label !== '' ? b.label : b.name)?.toLowerCase();

            if (aStr < bStr) {
                return -1;
            } else if (aStr > bStr) {
                return 1;
            }

            return 0;
        });
    }

    get currentTemplate() {
        return this.templateIdSelected !== null ? this.templates[this.templateIdSelected] : null;
    }

    get currentParametersConnection() {
        return this.templateIdSelected !== null
            ? this.parametersConnections[this.templateIdSelected]
            : null;
    }

    validate() {
        // this.tab.deleteReq = this.deleteReq;

        this.tab.dialogName = 'confirmation';

        this.tab.msg = `Cette action sera irréversible, et vous ne pourrez plus apporter de modifications par la suite. Êtes-vous sûr(e) de vouloir continuer?`;
        let dialogRef = this.dialog.open(DiaologHostComponent, {
            panelClass: 'filtre-dialog-component',
            data: {
                title: 'Confirmation de la validation',
                msg: this.tab.msg,
                tab: this.tab,
            },
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                let payload = {
                    produitDto: this.data,
                    champs: this.userService.getBackendRestrictionsChamps() || [],
                };
                this.httpclientService
                    .post(payload, `${this.tab.entite.toLowerCase()}/validateChampStatus`)
                    .subscribe((rs) => {
                        this.data = rs;
                        this.validationMessage(rs?.responseCode, rs?.code);

                        this.showIntermediaryApproverButton();
                    });
            }
        });
    }

    validationMessage(responseCode: string, produitCode: string) {
        {
            this.tab.dialogName = 'popup';
            if (responseCode === undefined || responseCode === null || responseCode !== '00') {
                this.tab.msg = `La validation du produit avec le code ${produitCode} a échoué. Veuillez contacter l'administrateur.`;
            } else {
                this.tab.msg = `La validation du produit avec le code ${produitCode} a réussi.`;
            }
            let dialogRef = this.dialog.open(DiaologHostComponent, {
                panelClass: 'filtre-dialog-component',
                data: {
                    title: 'Attention !',
                    msg: this.tab.msg,
                    tab: this.tab,
                },
            });
            return true;
        }
    }
    getData() {
        if (!this.tab.id) {
            this.isEditMode = true;
            this.lectureMode = false;

            this.templateIdSelected = this.tab.template.id;

            this.initAllParameters();

            return;
        }
        let url = `${this.tab.entite.toLowerCase()}/${this.tab?.id}`;

        this.httpclientService.get(url).subscribe((rs) => {
            this.data = rs;

            this.checkPatchTempData();

            this.templateIdSelected = this.findGoodTemplate();

            this.initAllParameters();

            if (this.auditLogs === null) {
                this.httpclientService
                    .get(`auditLog/${this.tab.entite.toLowerCase()}/${this.tab.id}`)
                    .subscribe((auditLogs) => (this.auditLogs = auditLogs));
            }

            this.showIntermediaryApproverButton();
        });
    }

    showFinalApproverButton() {
        let champs = this.userService.getBackendRestrictionsChamps() || [];
        if (this.data?.statut?.valeur === 'En production') {
            return false;
        }
        if (
            this.data?.statut?.valeur !== 'En production' &&
            this.data?.statut?.valeur !== 'Archivé' &&
            this.data?.statutTechnique?.valeur === 'Validé' &&
            this.data?.statutMarketing?.valeur === 'Validé' &&
            this.data?.statutTarif?.valeur === 'Validé' &&
            this.UserCanValidateFinalStatutField()
        ) {
            return true;
        }

        return false;
    }
    showEditButton() {
        let champs = this.userService.getBackendRestrictionsChamps() || [];
        if (
            this.UserCanValidateFinalStatutField() ||
            this.showIntermediaryApprovalButton ||
            !this.isApprovableEntite()
        ) {
            return true;
        }
        return false;
    }

    isApprovableEntite() {
        return this.entitiespourvalidation.indexOf(this.tab.entite.toLowerCase()) !== -1;
    }

    UserCanValidateFinalStatutField() {
        let champs = this.userService.getBackendRestrictionsChamps() || [];
        if (champs.indexOf('statut') !== -1) {
            return true;
        }
        return false;
    }
    showIntermediaryApproverButton() {
        let champs = this.userService.getBackendRestrictionsChamps() || [];
        if (this.isApprovableEntite() && this.UserCanValidateFinalStatutField()) {
            this.showIntermediaryApprovalButton = false;
        } else if (this.isApprovableEntite()) {
            let payload = {
                produitDto: this.data,
                champs,
            };
            this.httpclientService
                .post(payload, `${this.tab.entite.toLowerCase()}/verifyChampStatus`)
                .subscribe((rs) => {
                    if (!rs) {
                        this.showIntermediaryApprovalButton = true;
                    } else {
                        this.showIntermediaryApprovalButton = false;
                    }
                });
        }
    }
    async enrgister(event: Event) {
        event.preventDefault();
        if (this.isEditMode) {
            this.enrgisterData();
        } else if (this.isLayoutEditMode) {
            this.saveLayout();
        }
    }

    async enrgisterData() {
        // Save current tab data before merging all tabs
        let currentTabData: any = null;
        if (
            (this.isEditMode || this.isCreation) &&
            this.childComponents &&
            this.childComponents.length > 0
        ) {
            try {
                currentTabData = await this.templateService
                    .processEnregister(this.childComponents, this.tab, this.isDynamic, true)
                    .toPromise();

                if (currentTabData) {
                    if (this.isCreation && this.tab?.entite) {
                        // For creation mode: save with entity name
                        this.tabService.saveEditDataForCreation(
                            this.tab.entite,
                            currentTabData,
                            this.activeTab
                        );
                    } else if (this.tab?.id) {
                        // For edit mode: save with tab.id
                        this.tabService.saveEditData(
                            this.tab.id,
                            currentTabData,
                            false,
                            this.activeTab
                        );
                    }
                }
            } catch (error) {
                console.error('Error saving current tab data before save:', error);
            }
        }

        // Merge data from all tabs (including current tab)
        let allTabsData: any = null;
        if (this.isCreation && this.tab?.entite) {
            allTabsData = this.tabService.getAllTempEditDataForCreation(this.tab.entite);
        } else if (this.tab?.id) {
            allTabsData = this.tabService.getAllTempEditData(this.tab.id);
        }

        // Start with original data, then merge all tabs data
        // Current tab data is already included in allTabsData, but we prioritize it
        const baseData = { ...this.data };
        if (allTabsData) {
            Object.assign(baseData, allTabsData);
        }
        // Ensure current tab data takes precedence (most recent)
        if (currentTabData) {
            Object.assign(baseData, currentTabData);
        }

        await this.templateService
            .processEnregister(
                this.childComponents,
                this.tab,
                this.isDynamic,
                false,
                baseData,
                this.currentTemplate
            )
            .subscribe((rs) => {
                // Clear all temporary data after successful save
                if (this.isCreation && this.tab?.entite) {
                    // For creation mode: clear creation-specific data
                    this.tabService.clearTempEditDataForCreation(this.tab.entite);
                    this.tabService.clearActiveTabIndexForCreation(this.tab.entite);
                } else if (this.tab?.id) {
                    // For edit mode: clear edit-specific data
                    this.tabService.clearTempEditData(this.tab.id);
                }
                this.tempData = null;

                if (this.dynamicDocumentInfo) {
                    this.data = rs;
                    this.tab.id = rs?.id;
                    this.myTableService.updateOrAddItem(rs, this.tab.entite);
                    this.dash.changeNameOrTitleAfterSave(
                        this.tab,
                        this._dynamicDocumentService.getValue(
                            this.data,
                            this.dynamicDocumentInfo.tabField
                        )
                    );

                    if (this.data) {
                        this.errorMessage = this.data['responseMessage'];
                    }
                    this.setLectureMode(rs?.id ? rs.id : '');
                } else {
                    this.tab.id = rs.id;
                    this.myTableService.updateOrAddItem(rs, this.tab.entite); // this is to update the table
                    this.myTableService.updateTemplateData(rs.id, rs);
                    this.data = rs;

                    this.dash.changeNameOrTitleAfterSave(
                        this.tab,
                        this.tabService.getTabTitle(rs, this.languages, this.tab.entite)
                    );

                    this.showIntermediaryApproverButton(); // this is to update the template data

                    if (this.data) {
                        this.errorMessage = this.data['responseMessage'];
                    }
                    this.setLectureMode(rs?.id ? rs.id : '');
                }
            });
    }

    setLectureMode(id: string = '') {
        if (!this.tab.droitTitle && this.dynamicDocumentInfo) {
            this.tab.isDynamic = true;
            this.tab.id = id;
            this.tab.droitTitle = this._dynamicDocumentInfoService.getLabel(
                this.dynamicDocumentInfo
            );
        }

        if (!this.errorMessage) {
            this.tab.isEditMode = false;
            this.tab.edition = false;
            this.isEditMode = false;
            this.isLayoutEditMode = false;
            this.lectureMode = true;
            this.tab.value = 'lecture';

            if (this.tab.isRecordDuplication) {
                this.tab.id = id;
                delete this.tab['isRecordDuplication'];
                delete this.tab['data'];
                delete this.tab['templates'];
                delete this.tab['dynamicDocumentInfo'];
                this.tab.typeName = '';
                delete this.tab['templateIdSelected":'];
            }
        }
    }

    modeEdition() {
        this.lectureMode = false;
        this.isEditMode = true;
        this.tab.isEditMode = true;
        this.tab.edition = true;
        this.isLayoutEditMode = false;
        this.typeName = this.tab.entite;
        this.tab.value = 'edition';
    }

    hasTitleOnCols(cols: Col[]) {
        return cols.filter((col: Col) => col.title != null && col.title.trim() !== '').length > 0;
    }

    hasTitleOnRow(row: Row) {
        return row.title !== '';
    }

    supprimer() {
        // this.deleteReq.idList.push(this.tab.id);
        // this.tab.dialogName = 'supprime';
        // this.tab.deleteReq = this.deleteReq;
        this.deleteReq.idList.push(this.tab.id);
        this.tab.dialogName = 'supprime';
        this.tab.deleteReq = this.deleteReq;
        this.totalElements = this.tab.totalElements;

        this.tab.msg = `Voulez-vous vraiment supprimer les enregistrements`;
        let dialogRef = this.dialog.open(DiaologHostComponent, {
            panelClass: 'filtre-dialog-component',
            data: {
                title: 'Confirmation de la suppression',
                msg: `Voulez-vous vraiment supprimer les enregistrements`,
                tab: this.tab,
            },
        });
        dialogRef.afterClosed().subscribe((result) => {
            this.dash.openPrev(this.tab);
        });
    }

    duplicateRecord() {
        this._dynamicDocumentService.cloneById(this.tab.entite, this.tab.id).subscribe({
            next: (data) => {
                let record = new Tables();
                record.data = data;
                record.typeName = this.tab.entite;
                record.entite = this.tab.entite;
                record.droitTitle = this.tab.droitTitle;
                record.isDynamic = this.tab.isDynamic;
                record.templates = this.templates;
                record.title = this.tab.title + ' dupliqué';
                record.edition = true;
                record.templateIdSelected = this.templateIdSelected;
                record.isRecordDuplication = true;
                record.dynamicDocumentInfo = this.dynamicDocumentInfo;
                record.value = 'edition';
                if (record.data && record.data.uniqueId) {
                    record.data.uniqueId = null;
                }
                this.dash.editDuplicateRecord(record);
            },
            error: (error) => {},
        });
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////////
    //
    // Layout editor
    //
    ////////////////////////////////////////////////////////////////////////////////////////////////////////

    editLayout() {
        if (this.currentTemplate === null || this.templateIdSelected === null) {
            return;
        }

        if (this.currentTemplate.layout === undefined || this.currentTemplate.layout === null) {
            // For retrocompatibility
            this.templates[this.templateIdSelected].layout = {
                hasCondition: false,
                conditions: [],
                tabs: [
                    {
                        id: uuidv4(),
                        label: 'Informations générales',
                        rows: [
                            {
                                id: uuidv4(),
                                title: '',
                                cols: [
                                    {
                                        id: uuidv4(),
                                        title: '',
                                        parameters: this.currentTemplate.colonnegauche,
                                    },
                                    {
                                        id: uuidv4(),
                                        title: '',
                                        parameters: this.currentTemplate.colonnedroite,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            };
            this.templates[this.templateIdSelected].parameters = [];
        } else {
            this.sortParameters();
        }
        this.refreshParametersConnection();

        this.isLayoutEditMode = true;
        this.isEditMode = false;
        this.lectureMode = false;
    }

    private refreshParametersConnection() {
        if (this.currentTemplate === null || this.templateIdSelected === null) {
            return;
        }

        this.parametersConnections[this.templateIdSelected] =
            this.currentTemplate.layout.tabs.flatMap((tab: any) =>
                tab.rows.flatMap((row: any) => row.cols.map((col: any) => col.id))
            );
        this.parametersConnections[this.templateIdSelected].push('parameters');
    }

    private sortParameters() {
        if (this.currentTemplate === null || this.templateIdSelected === null) {
            return;
        }

        if (
            this.currentTemplate.parameters === undefined ||
            this.currentTemplate.parameters === null
        ) {
            this.templates[this.templateIdSelected].parameters = [];
        }

        /*
    this.templates[this.templateIdSelected].parameters.sort(
      (a: Parametre, b: Parametre) => {
        const aStr = (a.label !== '' ? a.label : a.name).toLowerCase();
        const bStr = (b.label !== '' ? b.label : b.name).toLowerCase();

        if (aStr < bStr) {
          return -1;
        } else if (aStr > bStr) {
          return 1;
        }

        return 0;
      }
    );
    */
        // handled null values of label and name in parameters
        this.templates[this.templateIdSelected].parameters = this.templates[
            this.templateIdSelected
        ].parameters
            .filter((param: Parametre) => param.name !== null)
            .sort((a: Parametre, b: Parametre) => {
                const aStr = (
                    a.label !== '' ? a?.label : a?.name !== '' ? a?.valeur : a?.valeur
                )?.toLowerCase();
                const bStr = (
                    b.label !== '' ? b?.label : b?.name !== '' ? a?.valeur : a?.valeur
                )?.toLowerCase();

                if (aStr < bStr) {
                    return -1;
                } else if (aStr > bStr) {
                    return 1;
                }

                return 0;
            });
    }

    onOpenLanguages(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.isOpenLanguages = !this.isOpenLanguages;
    }

    setDocumentName() {
        this.currentTemplate?.layout.tabs.forEach((tab) => {
            tab.rows.forEach((row) => {
                row.cols.forEach((col) => {
                    col.parameters.forEach((parametre) => {
                        if (this.currentTemplate?.entite)
                            parametre.entity = this.currentTemplate?.entite;
                    });
                });
            });
        });
    }

    saveLayout() {
        if (this.templateIdSelected !== null) {
            this.updateLanguagesFilter();

            this.setDocumentName();

            this.templateService
                .updateTemplate(this.templates[this.templateIdSelected])
                .subscribe(() => {
                    this.isEditMode = false;
                    this.isLayoutEditMode = false;
                    this.lectureMode = true;
                });
        }
    }

    cancelEditLayout() {
        this.isEditMode = false;
    }

    dropParameter(event: CdkDragDrop<any>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(
                event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex
            );
        }
    }

    dropRows(event: CdkDragDrop<any>, rows: any) {
        moveItemInArray(rows, event.previousIndex, event.currentIndex);
    }

    dropCols(event: CdkDragDrop<any>, cols: any) {
        moveItemInArray(cols, event.previousIndex, event.currentIndex);
    }

    onAddCol(cols: any, colId: any) {
        const index: number = cols.findIndex((col: any) => col.id === colId);
        if (index !== -1) {
            cols.splice(index + 1, 0, { id: uuidv4(), title: '', parameters: [] });
        }
        this.refreshParametersConnection();
    }

    onRemoveCol(cols: any, colId: any) {
        this.tab.dialogName = 'confirmation';
        this.tab.msg = `Voulez-vous vraiment supprimer cette colonne ?`;
        let dialogRef = this.dialog.open(DiaologHostComponent, {
            panelClass: 'filtre-dialog-component',
            data: {
                title: 'Confirmation de la suppression',
                tab: this.tab,
            },
        });

        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                const isLastCol = cols.length === 1;

                const index: number = cols.findIndex((col: any) => col.id === colId);
                if (index !== -1) {
                    // Retrieve parameters from col selected
                    cols[index].parameters.forEach((parameter: any) => {
                        if (this.templateIdSelected !== null) {
                            this.templates[this.templateIdSelected].parameters.push(parameter);
                        }
                    });
                    this.sortParameters();

                    // Remove col selected
                    cols.splice(index, 1);
                }
                if (isLastCol) {
                    cols.push({ id: uuidv4(), parameters: [] });
                }
                this.refreshParametersConnection();
            }
        });
    }

    onAddRow(rows: any, rowId: any) {
        const index: number = rows.findIndex((row: any) => row.id === rowId);
        if (index !== -1) {
            rows.splice(index + 1, 0, {
                id: uuidv4(),
                title: '',
                cols: [{ id: uuidv4(), title: '', parameters: [] }],
            });
        }
        this.refreshParametersConnection();
    }

    onRemoveRow(rows: any, rowId: any) {
        this.tab.dialogName = 'confirmation';
        this.tab.msg = `Voulez-vous vraiment supprimer cette ligne ?`;
        let dialogRef = this.dialog.open(DiaologHostComponent, {
            panelClass: 'filtre-dialog-component',
            data: {
                title: 'Confirmation de la suppression',
                tab: this.tab,
            },
        });

        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                const isLastRow = rows.length === 1;

                const index: number = rows.findIndex((row: any) => row.id === rowId);
                if (index !== -1) {
                    // Retrieve parameters from all cols from row selected
                    rows[index].cols
                        .flatMap((col: any) => col.parameters)
                        .forEach((parameter: any) => {
                            if (this.templateIdSelected !== null) {
                                this.templates[this.templateIdSelected].parameters.push(parameter);
                            }
                        });
                    this.sortParameters();

                    // Remove row selected
                    rows.splice(index, 1);
                }

                if (isLastRow) {
                    rows.push({
                        id: uuidv4(),
                        title: '',
                        cols: [{ id: uuidv4(), title: '', parameters: [] }],
                    });
                }

                this.refreshParametersConnection();
            }
        });
    }

    onAddTab() {
        if (this.templateIdSelected === null) {
            return;
        }

        const index: number = this.templates[this.templateIdSelected].layout.tabs.length;

        this.templates[this.templateIdSelected].layout.tabs.push({
            id: uuidv4(),
            label: `Onglet ${index}`,
            rows: [
                {
                    id: uuidv4(),
                    title: '',
                    cols: [{ id: uuidv4(), title: '', parameters: [] }],
                },
            ],
        });
        this.refreshParametersConnection();
    }

    onRemoveTab(index: number) {
        this.tab.dialogName = 'confirmation';
        this.tab.msg = `Voulez-vous vraiment supprimer cette onglet ?`;
        let dialogRef = this.dialog.open(DiaologHostComponent, {
            panelClass: 'filtre-dialog-component',
            data: {
                title: 'Confirmation de la suppression',
                tab: this.tab,
            },
        });

        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                if (this.templateIdSelected === null) {
                    return;
                }

                if (index > 0) {
                    // Retrieve parameters from tab selected
                    this.templates[this.templateIdSelected].layout.tabs[index].rows
                        .flatMap((row: any) => row.cols.flatMap((col: any) => col.parameters))
                        .forEach((parameter: any) => {
                            if (this.templateIdSelected !== null) {
                                this.templates[this.templateIdSelected].parameters.push(parameter);
                            }
                        });
                    this.sortParameters();

                    // Remove tab selected
                    this.templates[this.templateIdSelected].layout.tabs.splice(index, 1);

                    this.refreshParametersConnection();
                }
            }
        });
    }

    onChangeLanguage(language: Language) {
        if (language.key === 'all') {
            this.languages.forEach((l) => (l.selected = language.selected));
        } else if (language.selected === false) {
            const allLanguages = this.languages.find((l) => l.key == 'all');
            if (allLanguages !== undefined) {
                allLanguages.selected = false;
            }
        } else if (language.selected === true) {
            if (
                this.languages.length -
                    this.languages.filter((language) => language.selected).length ===
                1
            ) {
                const allLanguages = this.languages.find((l) => l.key == 'all');
                if (allLanguages !== undefined) {
                    allLanguages.selected = true;
                }
            }
        }

        this.updateLanguagesFilter();
    }

    private updateLanguagesFilter() {
        if (this.currentTemplate === null) {
            return;
        }

        const locales: string[] = this.languages
            .filter((language) => language.selected)
            .map((language) => language.key);

        if (this.currentTemplate.layout === null) {
            [...this.currentTemplate.colonnegauche, ...this.currentTemplate.colonnedroite].forEach(
                (parametre) => {
                    if (parametre.multiLangue !== undefined && parametre.multiLangue === true) {
                        // Reset all
                        parametre.parametres.forEach(
                            (sousParameter) => (sousParameter.visible = false)
                        );

                        // Filter
                        parametre.parametres.forEach((sousParameter) => {
                            if (locales.indexOf('all') !== -1) {
                                sousParameter.visible = true;
                            } else if (locales.indexOf(sousParameter.label) !== -1) {
                                sousParameter.visible = true;
                            }
                        });
                    }
                }
            );
        } else {
            this.currentTemplate.layout.tabs.forEach((tab) => {
                tab.rows.forEach((row) => {
                    row.cols.forEach((col) => {
                        col.parameters.forEach((parametre) => {
                            if (
                                parametre.multiLangue !== undefined &&
                                parametre.multiLangue === true
                            ) {
                                // Reset all
                                parametre.parametres.forEach(
                                    (sousParameter) => (sousParameter.visible = false)
                                );

                                // Filter
                                parametre.parametres.forEach((sousParameter) => {
                                    if (locales.indexOf('all') !== -1) {
                                        sousParameter.visible = true;
                                    } else if (locales.indexOf(sousParameter.label) !== -1) {
                                        sousParameter.visible = true;
                                    }
                                });
                            }
                        });
                    });
                });
            });
        }
    }

    @ViewChild('languagesElementRef') languagesElementRef: ElementRef;

    @HostListener('document:click', ['$event'])
    onCloseLanguages(event: any) {
        if (
            this.isOpenLanguages &&
            !this.languagesElementRef.nativeElement.contains(event.target)
        ) {
            this.isOpenLanguages = false;
            this.updateLanguagesFilter();
        }
    }

    cancel() {
        // For creation mode: Show popup confirmation before canceling
        // For edit mode: Just reset to read mode, no popup needed
        if (this.isCreation || this.tab.isRecordDuplication) {
            // Show confirmation dialog for creation mode
            this.tab.dialogName = 'confirmation';
            this.tab.msg = this.isCreation
                ? 'Êtes-vous sûr de vouloir annuler la création ? Toutes les données saisies seront perdues.'
                : 'Êtes-vous sûr de vouloir annuler ? Toutes les modifications non enregistrées seront perdues.';

            let dialogRef = this.dialog.open(DiaologHostComponent, {
                panelClass: 'filtre-dialog-component',
                data: {
                    title: this.isCreation
                        ? "Confirmation de l'annulation"
                        : "Confirmation de l'annulation",
                    tab: this.tab,
                },
            });

            dialogRef.afterClosed().subscribe((result: boolean) => {
                if (result) {
                    // User confirmed: proceed with cancel
                    this.performCancel();
                }
                // If result is false or undefined, user cancelled the confirmation dialog, do nothing
            });
        } else {
            // For edit mode: Just reset to read mode without popup
            this.performCancel();
        }
    }

    private performCancel() {
        // Clear all temporary data when canceling
        // This ensures data is cleared BEFORE closing tab or resetting form
        if (this.isCreation && this.tab?.entite) {
            // For creation mode: clear all creation-specific data
            this.tabService.clearTempEditDataForCreation(this.tab.entite);
            this.tabService.clearActiveTabIndexForCreation(this.tab.entite);
            this.activeTab = 0;
            // Reset form data for creation mode
            this.tempData = null;
            this.data = {};
        } else if (this.tab?.id) {
            // For edit mode: clear edit-specific data
            this.tabService.clearTempEditData(this.tab.id);
            this.tabService.clearActiveTabIndex(this.tab.id);
            this.activeTab = 0;
            // Reset form data for edit mode
            this.tempData = null;
        }

        // For creation mode or record duplication: close tab after clearing data
        // Mark tab as confirmedClose to prevent double popup in dashboard.removeTab()
        // Data has already been cleared above, so removeTab() will skip popup and just close tab
        if (this.tab.isRecordDuplication || this.isCreation) {
            (this.tab as any).confirmedClose = true;
            this.dash.openPrev(this.tab);
            return;
        }

        // For edit mode: Reset to read mode without closing tab
        this._dynamicDocumentService.findById('dynamic_category', this.tab.id, true).subscribe({
            next: (dynamicDocument: any) => {
                this.data = dynamicDocument;
            },
            error: () => {},
        });

        this.isEditMode = false;
        this.tab.isEditMode = false;
        this.tab.edition = false;
        this.tab.value = 'lecture';
        this.isLayoutEditMode = false;
        this.lectureMode = true;
        this.tempData = null;
        // this.templates = JSON.parse(JSON.stringify(this._initTemplates));
        // this.templateIdSelected = this.findGoodTemplate();
    }
    activeTab = 0;
    private previousActiveTab: number = 0;
    private isRestoringTab: boolean = false;

    async onTabChange(index: number) {
        // Skip if we're restoring tab (to avoid saving during restore)
        if (this.isRestoringTab) {
            return;
        }
        // Save data from current tab before switching (only if not switching to the same tab)
        if (
            (this.isEditMode || this.isCreation) &&
            index !== this.activeTab &&
            this.childComponents &&
            this.childComponents.length > 0
        ) {
            try {
                const tempData = await this.templateService
                    .processEnregister(this.childComponents, this.tab, this.isDynamic, true)
                    .toPromise();

                if (tempData) {
                    // Save data for the current tab index (before switching)
                    if (this.isCreation && this.tab?.entite) {
                        // For creation mode: use entity name
                        this.tabService.saveEditDataForCreation(
                            this.tab.entite,
                            tempData,
                            this.activeTab
                        );
                    } else if (this.tab?.id) {
                        // For edit mode: use tab.id
                        this.tabService.saveEditData(this.tab.id, tempData, false, this.activeTab);
                    }
                }
            } catch (error) {
                console.error('Error saving tab data:', error);
            }
        }

        // Update active tab
        this.previousActiveTab = this.activeTab;
        this.activeTab = index;

        // Save active tab index to localStorage for UX improvement
        if (this.isCreation && this.tab?.entite) {
            // For creation mode: save with entity name
            this.tabService.saveActiveTabIndexForCreation(this.tab.entite, index);
        } else if (this.tab?.id) {
            // For edit mode: save with tab.id
            this.tabService.saveActiveTabIndex(this.tab.id, index);
        }

        // Restore data for the new tab if it exists
        if (this.isEditMode || this.isCreation) {
            let savedData: any = null;
            if (this.isCreation && this.tab?.entite) {
                savedData = this.tabService.getTempEditDataForCreation(this.tab.entite, index);
            } else if (this.tab?.id) {
                savedData = this.tabService.getTempEditData(this.tab.id, index);
            }
            if (savedData) {
                this.tempData = savedData;
            } else {
                // If no saved data, use original data
                this.tempData = null;
            }
        }
    }

    downloadPDF() {
        const locales: string[] = this.languages
            .filter((language) => language.selected)
            .map((language) => language.key);

        for (const locale of locales) {
            if (this.tab.entite === 'produit') {
                this.httpclientService
                    .downloadBlob(`pdf/product/${this.tab.id}/${locale}`)
                    .subscribe((data: Blob) => {
                        const link: HTMLAnchorElement = document.createElement('a');
                        link.href = window.URL.createObjectURL(data);
                        link.download = `${this.tab.entite}-${this.tab.title}-${locale}.pdf`;
                        link.click();
                    });
            } else if (this.data !== undefined && this.data !== null && this.data.depth === 3) {
                this.httpclientService
                    .downloadBlob(`pdf/famille/${this.tab.id}/${locale}`)
                    .subscribe((data: Blob) => {
                        const link: HTMLAnchorElement = document.createElement('a');
                        link.href = window.URL.createObjectURL(data);
                        link.download = `${this.tab.entite}-${this.tab.title}-${locale}.pdf`;
                        link.click();
                    });
            } else {
                this.httpclientService
                    .downloadBlob(
                        `pdf/${this.dynamicDocumentInfo.documentName}/${this.dynamicDocumentInfo.id}/${locale}`
                    )
                    .subscribe((data: Blob) => {
                        const link: HTMLAnchorElement = document.createElement('a');
                        link.href = window.URL.createObjectURL(data);
                        link.download = `${this.tab.entite}-${this.tab.title}-${locale}.pdf`;
                        link.click();
                    });
            }
        }
    }

    onSearch(event: KeyboardEvent) {
        if (this.templateIdSelected === null) {
            return;
        }

        const search: string = (<any>event.target).value.toLowerCase();

        this.templates[this.templateIdSelected].parameters.sort((a: any, b: any) => {
            const aLabel = a.label?.toLowerCase();
            const aName = a.name?.toLowerCase();

            const bLabel = b.label?.toLowerCase();
            const bName = b.name?.toLowerCase();

            if (
                (aLabel.startsWith(search) && !bLabel.startsWith(search)) ||
                (aName.startsWith(search) && !bName.startsWith(search))
            ) {
                return -1;
            } else if (
                (!aLabel.startsWith(search) && bLabel.startsWith(search)) ||
                (!aName.startsWith(search) && bName.startsWith(search))
            ) {
                return 1;
            }

            return 0;
        });
    }

    onAddTemplate() {
        const ids: string[] = Object.keys(this.templates);
        const key = this.tab.entite + '-' + ids.length;

        const id = uuidv4();

        // Clone first template
        this.templates[id] = JSON.parse(JSON.stringify(this.templates[ids[0]]));
        this.templates[id].id = id;
        this.templates[id].titre = key;
        this.templates[id].layout = {
            hasCondition: true,
            conditions: [],
            tabs: [
                {
                    id: uuidv4(),
                    label: 'Informations générales',
                    rows: [
                        {
                            id: uuidv4(),
                            title: '',
                            cols: [
                                {
                                    id: uuidv4(),
                                    title: '',
                                    parameters: [],
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        this.templates[id].parameters = this.allParameters;

        this.allTemplates[id] = key;
        this.templateIdSelected = id;

        this.refreshParametersConnection();
    }

    onCloneTemplate() {
        const ids: string[] = Object.keys(this.templates);
        const key = this.tab.entite + '-' + ids.length;

        const id = uuidv4();

        // Clone previous template
        this.templates[id] = JSON.parse(JSON.stringify(this.currentTemplate));
        this.templates[id].id = id;
        this.templates[id].titre = key;
        this.templates[id].layout.hasCondition = true;

        this.allTemplates[id] = key;
        this.templateIdSelected = id;

        this.refreshParametersConnection();
    }

    hasCondition() {
        const ids: string[] = Object.keys(this.templates);
        return ids[0] !== this.templateIdSelected && this.currentTemplate?.layout.hasCondition;
    }

    onRemoveTemplate() {
        this.tab.dialogName = 'confirmation';
        this.tab.msg = `Voulez-vous vraiment supprimer ce template ?`;
        let dialogRef = this.dialog.open(DiaologHostComponent, {
            panelClass: 'filtre-dialog-component',
            data: {
                title: 'Confirmation de la suppression',
                tab: this.tab,
            },
        });

        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                if (this.currentTemplate === null) {
                    return;
                }

                const id: string = this.currentTemplate.id;
                const url: string = `template/${id}`;

                this.httpclientService.delete(url).subscribe(() => {
                    delete this.templates[id];
                    delete this.allTemplates[id];
                    this.templateIdSelected = Object.keys(this.allTemplates)[0];
                });
            }
        });
    }

    findGoodTemplate() {
        for (const id of Object.keys(this.templates)) {
            const layout = this.templates[id].layout;

            if (
                layout === undefined ||
                layout.conditions === undefined ||
                layout.conditions === null ||
                layout === null ||
                layout.hasCondition === false ||
                layout.conditions.length === 0
            ) {
                continue;
            }

            const conditions = layout.conditions;
            if (conditions) {
                for (const condition of conditions) {
                    const v = this.data[condition.key];
                    if (v === undefined || v === null) {
                        continue;
                    }

                    if (typeof v === 'boolean') {
                        if (
                            v === true &&
                            (condition.value === true ||
                                condition.value === 'true' ||
                                condition.value === 1 ||
                                condition.value === '1')
                        ) {
                            return id;
                        } else if (
                            v === false &&
                            (condition.value === false ||
                                condition.value === 'false' ||
                                condition.value === 0 ||
                                condition.value === '0')
                        ) {
                            return id;
                        }
                    }

                    if (
                        typeof v === 'object' &&
                        (v.valeur !== undefined || v.value !== undefined) &&
                        (v.valeur === condition.value ||
                            v.valeur?.toString() == condition.value.toString() ||
                            v.value === condition.value ||
                            v.value.toString() == condition.value.toString())
                    ) {
                        return id;
                    }
                    if (
                        Array.isArray(v) &&
                        v.find(
                            (item) =>
                                item.value === condition.value ||
                                item.value.toString() == condition.value.toString()
                        )
                    ) {
                        return id;
                    }

                    // for multi select value
                    if (Array.isArray(v) && Array.isArray(condition.value)) {
                        if (
                            v
                                .map((item) => item?.value)
                                .sort()
                                .join('_') === condition.value.sort().join('_')
                        ) {
                            return id;
                        }
                    }

                    // for input date value
                    if (typeof v === 'number' && typeof condition.value === 'string') {
                        if (this.datePipe.transform(v, 'yyyy-MM-dd') === condition.value) return id;
                    }

                    if (v === condition.value || v.toString() == condition.value.toString()) {
                        return id;
                    }
                }
            }
        }

        return this.templates[Object.keys(this.allTemplates)[0]]?.id;
    }

    onConditions(event: any) {
        event.preventDefault();

        this.tab.dialogName = 'layout-conditions';
        this.tab.template = this.currentTemplate;

        const dialogRef = this.dialog.open(DiaologHostComponent, {
            panelClass: 'filtre-dialog-component',
            data: {
                title: 'Conditions',
                msg: '',
                tab: this.tab,
            },
        });
        dialogRef.afterClosed().subscribe((conditions: LayoutCondition[]) => {
            if (this.templates !== null && this.templateIdSelected !== null) {
                this.templates[this.templateIdSelected].layout.conditions = conditions;
                this.templates[this.templateIdSelected].layout.hasCondition = true;
            }
        });
    }

    onClearTemplate() {
        this.tab.dialogName = 'confirmation';
        this.tab.msg = `Voulez-vous vraiment vider le template ?`;
        let dialogRef = this.dialog.open(DiaologHostComponent, {
            panelClass: 'filtre-dialog-component',
            data: {
                title: 'Confirmation de la suppression',
                tab: this.tab,
            },
        });

        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                if (this.templateIdSelected === null) {
                    return;
                }

                this.templates[this.templateIdSelected].layout.tabs = [
                    {
                        id: uuidv4(),
                        label: 'Informations générales',
                        rows: [
                            {
                                id: uuidv4(),
                                title: '',
                                cols: [
                                    {
                                        id: uuidv4(),
                                        title: '',
                                        parameters: [],
                                    },
                                ],
                            },
                        ],
                    },
                ];
                this.templates[this.templateIdSelected].parameters = this.allParameters;

                this.refreshParametersConnection();
            }
        });
    }

    hasAuditLogs(): boolean {
        if (this.auditLogs === undefined || this.auditLogs === null) {
            return false;
        }
        return this.auditLogs.length > 0;
    }

    onOpenArchive(event: any): void {
        event.preventDefault();

        if (this.auditLogs === undefined || this.auditLogs === null) {
            return;
        }

        this.tab.dialogName = 'archives';

        if (this.templateIdSelected !== null) {
            const fields = this.templates[this.templateIdSelected].layout.tabs
                .flatMap((t) => t.rows)
                .flatMap((r) => r.cols)
                .flatMap((c) => c.parameters)
                .map((p) => {
                    return { name: p.name, label: p.label };
                });

            this.tab.auditLogs = this.auditLogs.map((al) => {
                const field: { name: string; label: string } | undefined = fields.find(
                    (f) => f.name === al.fieldName
                );
                if (field !== undefined) {
                    al.fieldName = field.label;
                }
                return al;
            });
        }

        this.dialog.open(DiaologHostComponent, {
            panelClass: 'filtre-dialog-component',
            data: {
                title: 'Archive des modifications',
                tab: this.tab,
            },
        });
    }

    private retrieveDynamicDocumentInfo(documentName: string): Promise<DynamicDocumentInfo | null> {
        return new Promise<DynamicDocumentInfo | null>(
            (resolve: (dynamicDocumentInfo: DynamicDocumentInfo | null) => void, reject) => {
                this._dynamicDocumentInfoService.findByDocumentName(documentName).subscribe({
                    next: (dynamicDocumentInfo: DynamicDocumentInfo) => {
                        // Is dynamic document
                        resolve(dynamicDocumentInfo);
                    },
                    error: () => {
                        // Is static document
                        reject('Is static document');
                    },
                });
            }
        );
    }

    private retrieveDynamicDocument(documentName: string, id: string): Promise<any | null> {
        return new Promise<any | null>((resolve: (dynamicDocument: any | null) => void, reject) => {
            if (!id) {
                reject();
            } else {
                this._dynamicDocumentService.findById(documentName, id, true).subscribe({
                    next: (dynamicDocument: any) => {
                        // Found
                        resolve(dynamicDocument);
                    },
                    error: () => {
                        // Not found
                        reject('Pas de document existant');
                    },
                });
            }
        });
    }

    private toFormfield(fieldInfo: DynamicDocumentFieldInfo): string {
        let formfield: string = '';

        switch (fieldInfo.type) {
            case DynamicDocumentFieldInfoType.ID:
                formfield = 'textbox';
                break;

            case DynamicDocumentFieldInfoType.TEXT:
                formfield = 'textbox';
                if (fieldInfo.isMultilingual) formfield = 'multilanguetextbox';
                break;

            case DynamicDocumentFieldInfoType.NUMBER:
                formfield = 'textbox';
                break;

            case DynamicDocumentFieldInfoType.BOOLEAN:
                formfield = 'selection';
                break;

            case DynamicDocumentFieldInfoType.DATE_TIME:
                formfield = 'datefield';
                break;

            case DynamicDocumentFieldInfoType.RESOURCE_FILES:
                formfield = 'image';
                break;
            case DynamicDocumentFieldInfoType.MULTILANGUE_FORMATTED_TEXT:
                formfield = 'multilangueformattedtextbox    ';
                break;
            case DynamicDocumentFieldInfoType.FORMATTED_TEXT:
                formfield = 'formattedtextbox';
                if (fieldInfo.isMultilingual) formfield = 'multilanguetextbox';
                break;
            case DynamicDocumentFieldInfoType.DOCUMENT_LINK:
                formfield = 'table';
                break;

            case DynamicDocumentFieldInfoType.DOCUMENT_LINKS:
                formfield = 'table';
                break;

            case DynamicDocumentFieldInfoType.PARAMETER_LINK:
                formfield = 'selection';
                break;

            case DynamicDocumentFieldInfoType.PARAMETER_LINKS:
                formfield = 'multiselectiondropdown';
                break;
        }

        return formfield;
    }

    private toTemplate(dynamicDocumentInfo: DynamicDocumentInfo): Template {
        const locales: string[] = this.languages
            .filter((language) => language.selected)
            .map((language) => language.key);

        const parameters: Parametre[] = [];
        for (let field of dynamicDocumentInfo.fields) {
            // const fieldInfo: DynamicDocumentFieldInfo | undefined = dynamicDocumentInfo.fields.find((fieldInfo: DynamicDocumentFieldInfo) => fieldInfo.name === field);
            // if (fieldInfo === undefined) {
            //   continue;
            // }
            parameters.push(this.getNewFieldData(dynamicDocumentInfo, field, locales));
        }

        return {
            id: uuidv4(),
            entite: dynamicDocumentInfo.documentName,
            titre: dynamicDocumentInfo.documentName,
            action: '',
            nombrecolonne: 0,
            colonnedroite: [],
            colonnegauche: [],
            layout: {
                hasCondition: false,
                conditions: [],
                tabs: [
                    {
                        id: uuidv4(),
                        label: 'Informations générales',
                        rows: [
                            {
                                id: uuidv4(),
                                title: '',
                                cols: [
                                    {
                                        id: uuidv4(),
                                        title: '',
                                        parameters: parameters,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
            parameters: [],
        };
    }

    getNewFieldData(
        dynamicDocumentInfo: DynamicDocumentInfo,
        field: DynamicDocumentFieldInfo,
        locales: any[]
    ) {
        return {
            id: uuidv4(),
            entity: dynamicDocumentInfo.documentName,
            name: field.name,
            label: (<any>field.label)?.[locales[0]],
            formfield: this.toFormfield(field),
            nombrecolonne: 0,
            dropdownList: [],
            displayedColumns: ['delete'].concat(
                field.documentLinkFields ? field.documentLinkFields : ['id']
            ),
            isDynamic: true,
            documentLinkName: field.documentLinkName,
            referenceField: field.documentLinkReferenceField,
            entiteRelationProperte: field.documentLinkName,
            parameterLinkName: field.parameterLinkName,
            simpleMode:
                field.type.toLowerCase() ==
                DynamicDocumentFieldInfoType.BOOLEAN.toString().toLowerCase(),
            isModifiable: field.isModifiable,
            locales: this.languages.map((el) => el.key).slice(0, this.languages.length - 1),
            isVisible: field.isVisible,
            valeur: field,
            type: field.type,
            champs: ['delete'].concat(field.documentLinkFields ? field.documentLinkFields : ['id']),
            visible: field.isVisible,
            className: '',
            request: '',
            parametres: [],
            multiLangue: field.isMultilingual,
            list: [],
            file: null,
            fileList: null,
        };
    }

    checkReplaceData(
        dynamicDocumentInfo: DynamicDocumentInfo,
        fieldName: string,
        locales: any[],
        checkData: any
    ) {
        const field = dynamicDocumentInfo.fields.find((fi) => fi.name === fieldName);

        if (field) {
            const currentData: any = this.getNewFieldData(dynamicDocumentInfo, field, locales);

            checkData &&
                Object.keys(currentData).forEach((key) => {
                    if (
                        key !== 'id' &&
                        (!checkData.hasOwnProperty(key) || checkData[key] !== currentData[key])
                    ) {
                        checkData[key] = currentData[key];
                    }
                });
        }
    }
}
